import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { selectJobsListItems } from "../../../../../../redux/jobs/selector";
import { jobs } from "../../../../../../redux/jobs/action";
import { useNavigate } from "react-router-dom";
import { selectListItems } from "../../../../../../redux/library/selector";
import PageLoader from "../../../../../../components/PageLoader";
import storePersist from "../../../../../../redux/storePersist";
import _ from 'lodash';
import MobileViewTable from "../../../../../../common/components/mobile-view-table.component";
import InfiniteScroll from "react-infinite-scroll-component";

const TransportAgentJobsMobile = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [index, setIndex] = useState(1)
  const [hasMore, setHasMore] = useState();
  const libraryData = useSelector(selectListItems)
  const [rawData, setRawData] = useState<any>([])
  const [jobData, setJobData] = useState<any>([])
  const itemsData = useSelector(selectJobsListItems)
  const roleData = _.find(storePersist.get('userProfile')?.current?.items[0]?.Message?.Roles, ['Name', 'TransportAgent']);
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});

  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.OrderId', headerName: 'Order Id', search: true },
      { field: 'Message.DeliveryDateUtc', headerName: 'Schedule Date & Time', isDateValueFormat: true },
      { field: 'Message.IsRTOJOB', headerName: 'RTO JOB', cellRenderer: 'yesNoRenderer' },
      { field: 'Message.IsQCTask', headerName: 'QC Task', cellRenderer: 'yesNoRenderer' },
      {
        field: 'Message.LogisticsOrderStatusId',
        headerName: 'Order Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.LogisticsOrderStatus },
        sortable: true,
        filter: false, isRowColorDecider: true
      },
      {
        field: 'Message.ShippingStatusId',
        headerName: 'Shipment Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.ShippingStatus },
        sortable: true,
        filter: false, isRowColorDecider: true
      },
      { field: 'Message.PickupCode', headerName: 'Pickup Code' },
      { field: 'Message.DeliveryCode', headerName: 'Delivery Code' },
      { field: 'Message.CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true }
    ]);
  }

  const fetchJobs = async (_page: any, size: any) => {
    await dispatch(jobs.resetAction({ actionType: 'list' }))
    await dispatch(jobs.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/jobs/list`, entity: 'jobs', jsonData: {
        "PageNumber": _page,
        "PageSize": size,
        "SortField": "Id",
        "SortOrder": "desc",
        "Filters": [
          {
            "FieldName": "TransportAgentId",
            "FilterOperatorId": 1,
            "FieldValue": roleData?.Id,
            "FieldType": "number"
          }]
      }
    }))
  }

  const handleSearch = async (data: any) => {

    const searchCriteria = [{
      FieldName: "OrderId",
      FieldText: "OrderId",
      FieldType: 'text',
      FilterOperatorId: 6,
      FieldValue: data?.value
    }]
    await setJobData([])
    await dispatch(jobs.resetAction({ actionType: 'list' }))
    await dispatch(jobs.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/jobs/list`, entity: 'jobs', jsonData: {
        "PageNumber": index,
        "PageSize": 30,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
        "Filters": [
          {
            "FieldName": "TransportAgentId",
            "FilterOperatorId": 1,
            "FieldValue": roleData?.Id,
            "FieldType": "number"
          }]
      }
    }));
  }

  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload Jobs</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handlereload(),
    }
  ];

  const handlereload = async () => {
    await setJobData([])
    await fetchJobs(index, 10)
  }

  useEffect(() => {
    createColumnDefs()
    fetchJobs(index, 10)

  }, [])

  useEffect(() => {
    if (index > 1) {
      createColumnDefs()
      fetchJobs(index, 10)
    }

  }, [index])

  const fetchMoreData = () => {
    const prevIndex = index
    setIndex(prevIndex + 1);
  };

  useEffect(() => {
    if (itemsData?.result?.items) {
      setRawData(itemsData?.result?.items)
      setHasMore(itemsData?.result?.pagination?.HasNextPage)
    }
  }, [itemsData]);

  useEffect(() => {
    let formatedData = []
    rawData.map((data: any) => {
      formatedData.push({
        Context: data?.Context,
        Message: {
          Id: data?.Message?.Id,
          OrderId: data?.Message?.OrderId,
          IsRTOJOB: data?.Message?.IsRTOJOB,
          IsQCTask: data?.Message?.IsQCTask,
          DeliveryDateUtc: data?.Message?.ShipmentInfo?.DeliveryDateUtc,
          LogisticsOrderStatusId: data?.Message?.LogisticsOrderStatusId,
          ShippingStatusId: data?.Message?.ShipmentInfo?.ShippingStatusId,
          PickupCode: data?.Message?.PickupCode,
          DeliveryCode: data?.Message?.DeliveryCode,
          CreatedOnUtc: data?.Message?.CreatedOnUtc,
        }
      })
    })
    if (index > 1) {
      setJobData([...jobData, ...formatedData])
    } else {
      setJobData(formatedData)
    }

  }, [rawData])

  return (
    <>
      {itemsData?.isLoading && index == 1 ? <PageLoader />
        :

        <MobileViewTable
          dataLength={jobData.length}
          fetchMoreData={fetchMoreData}
          hasMore={hasMore}
          onSearch={handleSearch}
          additionButtons={additionButtons}
          columnData={columnDefs}
          rowData={jobData}
          onEdit={handleEdit}
          headingName="Jobs" />

      }
    </>

  );
};

export default TransportAgentJobsMobile;